import {
  ContentImageCollectionModel,
  ContentLinksCollectionModel
} from '@/modules/content/models/content-collection.model'
import { BasicUserResourceModel } from '@/modules/user/models/user-resource.model'

export interface ContentHeadingResourceModel {
  h1: Array<any | null>
  h2: Array<any | null>
  h3: Array<any | null>
  h4: Array<any | null>
}

export enum ContentFormat {
  HTML = 'html',
  PDF = 'pdf',
  WORD = 'docx',
  ZIP = 'zip',
}

export enum ContentTemplate {
  SIMPLE = 'simple',
  NORMAL = 'normal'
}

export interface ContentResourceModel {
  id: number
  title: string
  lead: string | null,
  content: string | null,
  word_count: number,
  links: ContentLinksCollectionModel[],
  keywords: string[] | null
  heading: ContentHeadingResourceModel | null,
  images: ContentImageCollectionModel[] | null,
  tags: string[] | null,
  created_at: string
  updated_at: string,
  main_image: string | null
  author?: BasicUserResourceModel
}

export interface BasicContentResourceModel {
  title: string | null
  keywords: string[] | null
  links: ContentLinksCollectionModel[],
  headings: ContentHeadingResourceModel | null,
  images: ContentImageCollectionModel[] | null,
  tags: string[] | null,
}
